import React from 'react';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { FILTERED_ACTIVE_STATES } from '../../../helpers/activeStates';

const ActiveStateFilter = () => (
  <IconFilter
    multiple
    hasApplyButton
    name="activeStates"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={FILTERED_ACTIVE_STATES}
  />
);

export default ActiveStateFilter;
